import PopoutModal from '@/components/modal/PopoutModal.vue'
import { useModal } from 'vue-final-modal'

export const popoutModal = useModal({
  component: PopoutModal,
  attrs: {
    onConfirm() {
      popoutModal.close()
    },
    url: '',
  },
})
